// filtri/compositore.ts — v043: gli strati del filtro, uguali nel motore della partita e nel banco di prova (prima
// il banco ricopiava il codice del motore). Due strati trasparenti grandi quanto il fotogramma:
//   1. la PELLE (trama incollata sul viso), senza ombra;
//   2. il DISEGNO del filtro (cappelli, orecchie, ali…), con l'ombra morbida se la categoria la vuole.
// Su tutti e due la bocca si svuota: chi gioca deve poter vedere l'altro ridere.
import type { Ellisse } from "./geometria.ts";
import type { PassaggioPelle } from "./pelle.ts";
import type { ContestoFiltro, Filtro, Volto } from "./tipi.ts";

function pulisci(s: CanvasRenderingContext2D, c: ContestoFiltro): void {
  s.setTransform(1, 0, 0, 1, 0, 0);
  s.globalAlpha = 1;
  s.globalCompositeOperation = "source-over";
  s.clearRect(0, 0, c.larghezza, c.altezza);
}

/** Strato della pelle. true se c'è qualcosa da appoggiare sul fotogramma. */
export function componiPelle(s: CanvasRenderingContext2D, pelle: PassaggioPelle, filtro: Filtro, c: ContestoFiltro, sorgente: TexImageSource, volto: Volto | null, zona: Ellisse | null): boolean {
  pulisci(s, c);
  if (!pelle.esegui(sorgente, c, volto)) return false;
  s.drawImage(pelle.canvas as CanvasImageSource, 0, 0, c.larghezza, c.altezza);
  if (zona) svuotaBocca(s, zona, filtro.bocca ?? "tutta");
  return true;
}

/** Strato del disegno (`disegna` del filtro). */
export function componiDisegno(s: CanvasRenderingContext2D, filtro: Filtro, c: ContestoFiltro, zona: Ellisse | null): boolean {
  if (!filtro.disegna) return false;
  pulisci(s, c);
  s.save();
  try {
    filtro.disegna(s, c);
  } finally {
    s.restore();
  }
  if (zona) svuotaBocca(s, zona, filtro.bocca ?? "tutta");
  return true;
}

/**
 * Toglie dallo strato ciò che copre la bocca (bordo morbido). Con "sotto" resta libera la parte bassa della zona
 * (dove la bocca si apre ridendo) e il filtro può coprire quella alta (dentoni, zanne, becco).
 */
export function svuotaBocca(s: CanvasRenderingContext2D, z: Ellisse, modo: "tutta" | "sotto" = "tutta"): void {
  s.save();
  s.globalCompositeOperation = "destination-out";
  s.translate(z.centro.x, z.centro.y);
  s.rotate(z.rotazione);
  if (modo === "sotto") {
    // in coordinate della zona +y = verso il mento: si svuota solo la metà bassa (da poco sotto la linea delle
    // labbra al bordo basso), dove la bocca si apre ridendo; sopra possono stare dentoni, zanne, becchi
    s.translate(0, z.ry * 0.55);
    s.scale(z.rx * 0.9, z.ry * 0.5);
  } else s.scale(z.rx, z.ry);
  const g = s.createRadialGradient(0, 0, 0, 0, 0, 1.15);
  g.addColorStop(0, "rgba(0,0,0,1)");
  g.addColorStop(0.8, "rgba(0,0,0,1)");
  g.addColorStop(1, "rgba(0,0,0,0)");
  s.fillStyle = g;
  s.fillRect(-1.2, -1.2, 2.4, 2.4);
  s.restore();
}
